import { render, staticRenderFns } from "./UploadAppButton.vue?vue&type=template&id=24ce12d4&scoped=true"
import script from "./UploadAppButton.vue?vue&type=script&lang=js"
export * from "./UploadAppButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ce12d4",
  null
  
)

export default component.exports